import {ISpecification} from "@/models/specifications/SpecificationHelpers/ISpecification";
import {IShipmentStore} from "@/models/StoreModels";
import {isEmpty, isNil} from "ramda";

export class StoreShipmentPhoneIsCorrect implements ISpecification<IShipmentStore> {
  // the only difference between IShipmentStore and ICrosstownApi is in the phone. In store we save the extension and
  // the phone in different values. However the specification is the same because we only need the phone number,
  // the extension is not mandatory

  public IsSatisfiedBy(candidate: IShipmentStore): boolean {
    return !isNil(candidate.to_phone_number) &&
      !isEmpty(candidate.to_phone_number);
  }
}
